import {inject, Injectable, Injector} from "@angular/core";
import {concat, forkJoin, Observable, reduce,} from "rxjs";
import {VersaoHttpService} from "../persist/http/VersaoHttpService";
import {Versao} from "../../domain/Versao";
import {Toast} from "@capacitor/toast";
import {Download} from "./download/Download";
import {HttpClient} from "@angular/common/http";
import LocalDataSource from "../../data-sources/LocalDataSource";
import {Bioma} from "../../domain/Bioma";
import {TipoAreaAmostral} from "../../domain/enums";
import {Taxon} from "../../domain/Taxon";
import {Pessoa} from "../../domain/Pessoa";
import {Local} from "../../domain/Local";
import {SQLiteService} from "../sqlite.service";
import {DownloadLocal} from "./download/DownloadLocal";
import {Comportamento} from "../../domain/Comportamento";
import {Droga} from "../../domain/Droga";
import {TipoMarcacao} from "../../domain/TipoMarcacao";
import {UnidadeMedida} from "../../domain/UnidadeMedida";
import {Projeto} from "../../domain/Projeto";
import {Jornada} from "../../domain/Jornada";
import {Especime} from "../../domain/Especime";
import {Monitoramento} from "../../domain/Monitoramento";
import {Arquivo} from "../../domain/Arquivo";
import {Campanha} from "../../domain/Campanha";
import {MetodoAmostragem} from "../../domain/MetodoAmostragem";
import {MicroRH} from "../../domain/MicroRH";
import {Municipio} from "../../domain/Municipio";
import {Fitofisionomia} from "../../domain/Fitofisionomia";
import {AbstractUpload} from "./upload/AbstractUpload";
import {UploadProjeto} from "./upload/UploadProjeto";
import {CursoDagua} from "../../domain/CursoDagua";
import {UploadPessoa} from "./upload/UploadPessoa";
import {UploadLocal} from "./upload/UploadLocal";
import {UploadEspecime} from "./upload/UploadEspecime";
import {UploadMonitoramento} from "./upload/UploadMonitoramento";
import {UploadJornada} from "./upload/UploadJornada";
import {UploadArquivo} from "./upload/UploadArquivo";


@Injectable()
export class Sincronizador {
    public enviar: AbstractUpload<any>[]
    public receber: Download<any>[]

    constructor(  private httpVersao: VersaoHttpService, http: HttpClient, sql:  SQLiteService){
        this.enviar = [
            inject(UploadProjeto),
            inject(UploadPessoa),
            inject(UploadLocal),
            inject(UploadJornada),
            inject(UploadMonitoramento),
            inject(UploadEspecime),
            inject(UploadArquivo)

        ]
        this.receber= [
            new Download(http, "Bioma","bioma", Bioma, sql),
            new Download(http, "MicroRH","microrh", MicroRH, sql),
            new Download(http, "Municipio","municipio", Municipio, sql),
            new Download(http, "Fitofisionomia","fitofisionomia", Fitofisionomia, sql),
            new Download(http, "CursodAgua","cursodagua", CursoDagua, sql),
            new Download(http, "Comportamento","comportamento", Comportamento, sql),
            new Download(http, "Droga","droga", Droga, sql),
            new Download(http, "Tipo Marcação","tipomarcacao", TipoMarcacao, sql),
            new Download(http, "Unidade Medida","unidademedida", UnidadeMedida, sql),
            new Download(http,"Táxon","taxon", Taxon,sql),

            new Download(http,"Pessoa","pessoa", Pessoa,sql),
            new DownloadLocal(http,"Local","local", Local,sql),
            new Download(http,"Projeto","projeto", Projeto,sql),
            new Download(http,"Campanha","campanha", Campanha,sql),
            new Download(http,"Método Amostragem","metodoamostragem", MetodoAmostragem,sql),
            new Download(http,"Jornada","jornada", Jornada,sql),
            new Download(http,"Monitoramento","monitoramento", Monitoramento,sql),
            new Download(http,"Indíviduo","especime", Especime,sql),
            new Download(http,"Arquivo","arquivo", Arquivo,sql),
        ]
    }

    verificarSincronizacao(){
        this.httpVersao.getVersao().subscribe({
            next: (v) => {
                this.baixar(v).then(r => {
                    // this.snack.dismiss()
                    console.log('baixou')
                    this.send().then()
                })

            },
            error: (e) => {
                console.log(e)
                // this.snack.open('Erro ao baixar versões do servidor' + e.message, "Ocultar", {duration: undefined})
            }
        }
        )
    }

    async send(){
        for (const i of this.enviar) {
            await i.sendRecords();
        }
    }

    async baixar(versoes: Versao[]){
        const baixaveis = []
        console.log(this.receber)
        for (const i of this.receber) {
            const r = await i.checkSincronizacao(versoes)
            if(r){
                console.log('Sincronizar',i.sentido,  i.nomeEntidade)
                baixaveis.push(i.sinc())
            }
        }
        // concat(baixaveis).subscribe(r=>{
        //     console.log('baixando')
        //     this.snack.open('Baixando atualizações' , "Ocultar", {duration: undefined})
        // })

        concat(...baixaveis).pipe(
            //necessário para receber somente uma notificação de finalizado
            reduce((acc,val) => {
                return 1
            })
        ).subscribe({
            next: (v) => {

                // this.snack.dismiss()
            },
            error: (e) =>  {
                console.log(e)
                Toast.show({
                text: `initializeAppError: ${e.message}`,
                duration: 'long'
              }).then();
                // this.snack.open('Erro ao baixar. ' + e.message , "Ocultar", {duration: 5000})
            }
        })
    }
}
